import { type OptionsFetchQueryResult, OptionsType } from '@openx/types/options.ts';
import type { UseQueryOptions } from '@openx/types/reactQuery.ts';
import { useTranslation } from 'react-i18next';

import { useOptionsFetch } from './generics/useOptionsFetch.tsx';

export function useConnectionSpeedOptionsFetch(queryOptions?: UseQueryOptions<OptionsFetchQueryResult>) {
  const { t } = useTranslation();
  const {
    isLoading: isConnectionSpeedLoading,
    data: connectionSpeedOptions,
    refetch: refetchOptions,
  } = useOptionsFetch({
    errorMessage: t('Failed to fetch Connection Speed options'),
    optionType: OptionsType.CONNECTION_SPEED,
    queryOptions,
  });

  return {
    connectionSpeedOptions,
    isConnectionSpeedLoading,
    refetchOptions,
  };
}
